/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Class_CitationInputs */

const en_reading_class_citation = /** @type {(inputs: Reading_Class_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In-text citations`)
};

const es_reading_class_citation = /** @type {(inputs: Reading_Class_CitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citas en el texto`)
};

/**
* | output |
* | --- |
* | "In-text citations" |
*
* @param {Reading_Class_CitationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_class_citation = /** @type {((inputs?: Reading_Class_CitationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Class_CitationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_class_citation(inputs)
	return en_reading_class_citation(inputs)
});